<div class="banner margin-bottom" role="banner">
  <h1>{{ 'earn.page.title' | translate }}</h1>
</div>

<div class="container">
  <fgbcl-earn-points></fgbcl-earn-points>
</div>
